module.exports = __webpack_public_path__ + "static/media/Arrow1.cb3f4869.jpg";